import { Helmet } from "react-helmet";
import { Box } from "@mantine/core";
import HeroSection from "../components/homepage/HeroSection/HeroSection";
import PropertyByCity from "../components/homepage/PropertyByCity/PropertyByCity";
import Offer from "../components/homepage/Offer";
import PropertyPurpose from "../components/homepage/PropertyPurpose/PropertyPurpose";
import AddedToday from "../components/homepage/AddedToday/AddedToday";
import HowItWorks from "../components/homepage/HowItWorks/HowItWorks";
import InfoBar from "../components/homepage/InfoBar/InfoBar";
import BlogListSection from "../admin/dashboard/blog/blogHome/BlogListSection";
import SocialMedia from "../components/homepage/social-media/SocialMedia";
import PromoBanner from "../components/homepage/PromoBanner/PromoBanner";

function HomePage() {
  return (
    <Box>
      <Helmet>
        <title>
          Find Your Dream Home – Buy or Rent with All Home Desire | Properties
          Online
        </title>
        <meta
          name="description"
          content="Discover Your Dream Property in India with All Home Desire - The Best Site for Buying, Selling, and Renting Residential and Commercial Real Estate"
        />
        <meta
          name="keywords"
          content="real estate, property in India, properties, property sites India, apartments near me, apartments for rent, houses for sale near me, homes for sale near me, apartments, apartments for rent near me, sell my house, houses for sale, we buy houses, houses for rent near me, sell my house fast, homes for sale"
        />
      </Helmet>
      {/* <Affix position={{ bottom: 20, right: 20 }} zIndex={100}>
        <Button
          component={Link}
          to="/partnerreg"
          size="lg"
          radius="xl"
          leftSection={<UserPlus size={20} />}
          style={{ 
            backgroundColor: '#1971c2',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)' 
          }}
        >
          Become A Partner
        </Button>
      </Affix> */}
      <HeroSection />
      <PropertyPurpose />
      <AddedToday />
      <PropertyByCity />
      <HowItWorks />
      <Offer />
      <PromoBanner />
      <BlogListSection />
      <SocialMedia />
      <InfoBar />
      {/* <AboutUsTwo /> */}
      {/* <AboutUs /> */}
    </Box>
  );
}

export default HomePage;
